import { Component, OnInit, ChangeDetectorRef, NgZone, ViewEncapsulation, HostListener } from '@angular/core';
import * as M from "materialize-css/dist/js/materialize";
//import { AngularFireDatabase } from 'angularfire2/database';
import * as _moment from 'moment';
import { saveAs } from 'file-saver';
import { DateTimeAdapter } from 'ng-pick-datetime';
//import * as Chartist from 'chartist';
import { AuthService, DataService } from '../../_services';

@Component({
  selector: 'app-data-viewer',
  templateUrl: './data-viewer.component.html',
  styleUrls: ['./data-viewer.component.css'],
  //encapsulation : ViewEncapsulation.Native
  //changeDetection: ChangeDetectionStrategy.Default
})
export class DataViewerComponent implements OnInit {
  public selectedMoment = new Date();

  constructor(
    private ngZone: NgZone,
    private changeDetector : ChangeDetectorRef,
    //public db: AngularFireDatabase,
    public svcAuth: AuthService,
    public svcData: DataService,
    dateTimeAdapter: DateTimeAdapter<any>
  ) { 
    //dateTimeAdapter.setLocale('fr-FR'); // change locale to Japanese
  }
  @HostListener('click', ['$event']) onClick(e) {
    if(e.target.classList.contains('li_area')){
      this.pageData.areaIndex = -1;
      var _title = e.target.innerHTML;
      this.pageData.areas.forEach((rec, iRec)=>{
        if(_title == rec.title){
          this.pageData.areaIndex = iRec
        }
      });
    }
  }
  pageData = {
    account: {
      //fullName: '', email: '', password: '', confirmPassword: '', contactNo: '', imageUrl: '', role: 'ADMIN', title: ''
      fullName: 'Geek', email: 'geek@gmail.com', password: 'pwd4Geek', confirmPassword: 'pwd4Geek', contactNo: '12345678', imageUrl: '', role: 'ADMIN', title: 'Manager'
    },
    viewMode: 'LIST',
    userList: [],
    areas:[],
    areas4Occupancy:[],
    areaIndex: -1,
    inValue: 0, outValue: 0, occupancyValue: 0,
    data: [],
    cDataEntry: [],
    cDataExit: [],
    cDataOccupancy: [],
    autoRefresh: false
  }
  isLoading = true;
  area:any;
  ngOnInit() {
    this.areaListLoad();
  }
  ngAfterViewInit(){
    //console.log('this is ngAfterViewInit');
    this.svcData.usageAdd('{"userId":"'+JSON.parse(localStorage.getItem("currentUser")).userId+'","code":"DATAVIEWER-VIEW","actionCode":"DATAVIEWER-VIEW"}').subscribe();
  }
  areaListLoad(){
    this.svcData.areaListAll().subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.pageData.areas = res.data;
      this.pageData.areas.push({areaId: '0', areaName: '-- ALL --'})
      //console.log(this.pageData.areas);
      var elems = document.querySelectorAll('.dropdown-trigger');
      M.Dropdown.init(elems, {});
      this.areaSelect(this.pageData.areas[0]);
    });
  }
  dataLoad(){
    //this.loading(true);
    var _startTime = _moment(this.selectedMoment).format('YYYYMMDD010000');
    var _endTime = _moment(this.selectedMoment).format('YYYYMMDD235959');
    
    this.svcData.sensorData(this.area.areaId, _startTime, _endTime).subscribe(res=>{
      this.loading(false);
      //console.log(res);
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.pageData.inValue = 0;
      this.pageData.outValue = 0;
      this.pageData.data = res.data;

      this.pageData.cDataEntry = [];
      this.pageData.cDataExit = [];
      this.pageData.cDataOccupancy = [];

      var cIntervals = this.chartIntervals();
      cIntervals.forEach(x=>{
        this.pageData.cDataEntry.push(0);
        this.pageData.cDataExit.push(0);
        this.pageData.cDataOccupancy.push(0);
      })

      this.pageData.data.forEach(x=>{
        this.pageData.inValue +=  x.inValue;
        
        var _outValue = 0;
        if(this.pageData.inValue < this.pageData.outValue + x.outValue){
          var _xValue = (this.pageData.outValue + x.outValue) - this.pageData.inValue;
          _outValue = x.outValue - _xValue;
          //this.pageData.outValue 
        }
        else{
          //this.pageData.outValue += x.outValue;
          _outValue = x.outValue;
        }
        this.pageData.outValue += x.outValue;

        var _occupancy = this.pageData.inValue - this.pageData.outValue;
        if(_occupancy<0) _occupancy = 0;
        var iHour = _moment(x.timestamp).format('H');
        this.pageData.cDataEntry[iHour] = x.inValue;
        this.pageData.cDataExit[iHour] = _outValue;
        this.pageData.cDataOccupancy[iHour] = _occupancy;

        //console.log(`${x.inValue} | ${x.outValue} --- ${_outValue}`);
      });
      if(this.pageData.inValue<this.pageData.outValue){
        this.pageData.inValue = this.pageData.outValue;
      }
      this.pageData.occupancyValue = this.pageData.inValue - this.pageData.outValue;
      if(this.pageData.occupancyValue<0) this.pageData.occupancyValue = 0;

      //this.chartBind();
    });
  }
  dataLoad4Occupancy(){
    this.pageData.areas4Occupancy = [];
    //console.log('today');
    this.svcData.areaListForOccupancy().subscribe(res=>{
      //console.log(res);
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.pageData.areas4Occupancy = res.data;
      var _loadedOA = 0;
      this.pageData.areas4Occupancy.forEach(rec=>{
        rec.occupancyTitle = '-';
        var _startTime = _moment(this.selectedMoment).format('YYYYMMDD010000');
        var _endTime = _moment(this.selectedMoment).format('YYYYMMDD235959');

        
        this.svcData.sensorData(rec.areaId, _startTime, _endTime).subscribe(resOccupancy=>{
          _loadedOA++;
          if(resOccupancy.status != 'OK'){
            this.showAlert(resOccupancy.message);
            return;
          }
          var _dataOccupancy = resOccupancy.data;

          this.pageData.cDataEntry = [];
          this.pageData.cDataExit = [];
          this.pageData.cDataOccupancy = [];

          var cIntervals = this.chartIntervals();
          cIntervals.forEach(x=>{
            this.pageData.cDataEntry.push(0);
            this.pageData.cDataExit.push(0);
            this.pageData.cDataOccupancy.push(0);
          })

          var _inValue = 0, _outValue = 0;
          _dataOccupancy.forEach(x=>{
            _inValue +=  x.inValue;

            var _oValue = 0;
            if(_inValue < _outValue + x.outValue){
              var _xValue = (_outValue + x.outValue) - _inValue;
              _oValue = x.outValue - _xValue;
            }
            else{
              _oValue = x.outValue;
            }
            _outValue += _oValue;
            //_outValue += x.outValue;

            var _occupancy = _inValue - _outValue;
            if(_occupancy<0) _occupancy = 0;
          });
          rec.occupancyTitle = _inValue - _outValue;
          if(rec.occupancyTitle <0) rec.occupancyTitle = 0;
          if(_loadedOA == 3){  //-- DMS
            // console.log('DMS - Occupancy');
            // console.log(this.pageData.areas4Occupancy);
          }
        });
      });
    });
  }
  dateChange(){
    //console.log(this.selectedMoment);
    //this.dataLoad();
    this.dataLoad4Sensor();
  }
  areaSelect(arg){
    this.svcData.areaDetail(arg.areaId).subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.area = res.data;
      if(arg.areaId == '0'){
        this.area.areaId = '0';
        this.area.areaName = '-- ALL --';
      }
      this.dataLoad4Sensor();
    });
  }
  dataLoad4Sensor(){
    // console.log(this.area.openingTime);
    // console.log(this.area.closingTime);
    var _startTime = _moment(this.selectedMoment).format('YYYYMMDD') + _moment(this.area.openingTime).format('HH0000');
    var _endTime = _moment(this.selectedMoment).format('YYYYMMDD') + _moment(this.area.closingTime).format('HH5959');
    var _sH = _moment(this.area.openingTime).hour();
    var _eH = _moment(this.area.closingTime).hour(); 
    this.area.intervals = this.timeValueList(_sH, _eH);
    this.area.sData = this.timeValueList(_sH, _eH);
    this.area.oData = this.timeValueList(_sH, _eH);
    this.pageData.inValue = 0;
    this.pageData.outValue = 0;
    var _loadedCount = 0;
    this.isLoading = true;
    //console.log(this.area);
    //if(1==1) return;

    if(this.area.areaId != '0'){
      this.area.sensors.forEach((s, iS) => {
        this.svcData.sensorDataBySensor(this.area.areaId, s.sensorId, _startTime, _endTime).subscribe(d=>{
          _loadedCount++;
          //console.log(s);
          if(d.status != 'OK'){
            this.showAlert(d.message);
            return;
          }
          s.data = d.data;
          s.sData = this.timeValueList(_sH, _eH);
          s.inValue = 0;
          s.outValue = 0;
          s.data.forEach(sData => {
            s.sData.forEach((t, iT) => {
              if(t.time == _moment(sData.timestamp).format('H') + 'hr'){
                t.inValue = sData.inValue;
                t.outValue = sData.outValue;
                //console.log(t);
  
                this.area.sData[iT].inValue += sData.inValue;
                this.area.sData[iT].outValue += sData.outValue;
  
                this.pageData.inValue += sData.inValue;
                this.pageData.outValue += sData.outValue;

                s.inValue += sData.inValue;
                s.outValue += sData.outValue;
              }
            });
          });
  
          if(_loadedCount == this.area.sensors.length){
            this.isLoading = false;
            var _occupancy = 0;
            this.area.sData.forEach((d, iD) => {
              _occupancy += d.inValue - d.outValue;
              if(_occupancy<0) _occupancy = 0;
              this.area.oData[iD].inValue = _occupancy;
            });
            // var _self = this;
            // window.setTimeout(function(){
            //   var _occupancy = 0;
            //   _self.area.sData.forEach((d, iD) => {
            //     _occupancy += d.inValue - d.outValue;
            //     if(_occupancy<0) _occupancy = 0;
            //     _self.area.oData[iD].inValue = _occupancy;
            //   });
            // }, 500);
            //console.log('here all done');
          }
          
          //console.log(this.area);
        });
      });
    }
    else{
      var _delay = 300;
      var _self = this;
      this.area.sensors.forEach((s, iS) => {
        setTimeout(function(){
          _self.svcData.sensorDataBySensorAlone(s.sensorId, _startTime, _endTime, _self.area.timezoneMinute).subscribe(d=>{
          _loadedCount++;
          //console.log(_loadedCount + ' vs ' + _self.area.sensors.length);
          if(_loadedCount == _self.area.sensors.length){
            _self.isLoading = false;
          }
          //console.log(d);
          if(d.status != 'OK'){
            _self.showAlert(d.message);
            return;
          }
          s.data = d.data;
          s.sData = _self.timeValueList(_sH, _eH);
          s.data.forEach(sData => {
            s.sData.forEach((t, iT) => {
              if(t.time == _moment(sData.timestamp).format('H') + 'hr'){
                t.inValue = sData.inValue;
                t.outValue = sData.outValue;
                //console.log(t);
  
                _self.area.sData[iT].inValue += sData.inValue;
                _self.area.sData[iT].outValue += sData.outValue;
  
                _self.pageData.inValue += sData.inValue;
                _self.pageData.outValue += sData.outValue;
              }
            });
          });
  
          if(_loadedCount == _self.area.sensors.length){
            var _occupancy = 0;
            _self.area.sData.forEach((d, iD) => {
              _occupancy += d.inValue - d.outValue;
              if(_occupancy<0) _occupancy = 0;
              _self.area.oData[iD].inValue = _occupancy;
            });
            // var _self = this;
            // window.setTimeout(function(){
            //   var _occupancy = 0;
            //   _self.area.sData.forEach((d, iD) => {
            //     _occupancy += d.inValue - d.outValue;
            //     if(_occupancy<0) _occupancy = 0;
            //     _self.area.oData[iD].inValue = _occupancy;
            //   });
            // }, 500);
            //console.log('here all done');
          }
        });
        }, _delay*iS);
      });
    }
  }
  chartIntervals(){
    var arrHr = [];
    for(var i=0;i<24;i++){
      arrHr.push(i + 'hr');
    }
    return arrHr;
  }
  
  dataExportCsv() {
    // const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
    // const header = Object.keys(data[0]);
    // let csv = data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    // csv.unshift(header.join(','));
    // let csvArray = csv.join('\r\n');

    // var blob = new Blob([csvArray], {type: 'text/csv' })
    // saveAs(blob, "Attendance_AuditLog.csv");

    var _nl = '\r\n';
    var csv = _moment(this.selectedMoment).format('D/MM/YYYY') + ',';
    this.area.intervals.forEach(x => {
      csv += x.time + ',,';
    });
    csv += _nl;
    csv += `${this.area.areaName},`;
    this.area.sData.forEach(d => {
      csv += `${d.inValue},${d.outValue},`;
    });
    //console.log(csv);

    this.area.sensors.forEach(s => {
      csv += _nl + s.sensorId + ',';
      s.sData.forEach(sd => {
        csv += `${sd.inValue},${sd.outValue},`;
      });
    });
    var blob = new Blob([csv], {type: 'text/csv' })
    saveAs(blob, "exportData.csv");

  }
  loading(arg){
    var _self = this;
    this.ngZone.run(()=>{ _self.isLoading = arg; });
  }
  showAlert(msg){
    //alert(msg);
    M.toast({html: msg});
  }
  timeValueList(startHour, endHour){
    var _arr = [];
    for(var i=startHour; i<=endHour; i++){
      _arr.push({time: i+'hr', inValue: 0, outValue: 0, occ: 0});
    }
    return _arr;
  }
  userForm(arg){
    this.pageData.viewMode = 'FORM';
  }
  
}
